var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"carmera"},[_c('video',{attrs:{"id":"QRvideo","muted":"","autoplay":"","playsinline":""},domProps:{"muted":true}}),_vm._v(" "),_c('canvas',{attrs:{"id":"qr-canvas"}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("扫码查真伪")]),_vm._v(" "),_c('div',{attrs:{"id":"scan"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53111528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/example01/index.vue
// module id = null
// module chunks = 